export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(";").shift();

    return cookieValue ? decodeURIComponent(cookieValue) : null;
  } else {
    return null;
  }
};

export type UpdateCookieLifespanOptions = {
  cookieValue: string;
};

export const updateCookieLifespan = (
  cookieName: string,
  seconds: number,
  options?: UpdateCookieLifespanOptions
) => {
  const cookieValue = options?.cookieValue ?? getCookie(cookieName);

  if (cookieValue) {
    const parts = cookieValue.split(";");

    const expirationDate = new Date();

    expirationDate.setSeconds(expirationDate.getSeconds() + seconds);

    const newValue = parts
      .map(part => {
        if (part.toLowerCase().includes("expires")) {
          return `expires=${expirationDate.toUTCString()}`;
        } else if (part.toLowerCase().includes("max-age")) {
          return `max-age=${seconds}`;
        } else {
          return part.trim();
        }
      })
      .join("; ");

    document.cookie = `${cookieName}=${newValue}`;
  }
};
